import React, { useState } from 'react';
import axios from 'axios';
import { Sparkles, X, Wand2 } from 'lucide-react';
import { API, cardCls, txtMain, txtSub } from './nlShared';
import { toast } from 'sonner';

export async function aiImprove(text, brief) {
  const { data } = await axios.post(`${API}/admin/nl/ai`, { mode: 'improve', text, brief }, { withCredentials: true });
  return data.text;
}

export function NlAiModal({ light, camp, onClose, onApplySubject, onApplyBlocks }) {
  const [tab, setTab] = useState('subject');
  const [brief, setBrief] = useState('');
  const [busy, setBusy] = useState(false);
  const [subjects, setSubjects] = useState(null);
  const [full, setFull] = useState(null);

  const generate = async () => {
    if (!brief.trim()) return toast.error('Décrivez le thème de votre newsletter');
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/nl/ai`, { mode: tab, brief, category: camp.category }, { withCredentials: true });
      if (tab === 'subject') setSubjects(data.suggestions || []);
      else setFull(data);
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur de génération'); }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/75 flex items-center justify-center p-4" onClick={onClose} data-testid="nl-ai-modal">
      <div className={`${cardCls(light)} w-full max-w-lg max-h-[88vh] overflow-y-auto p-5`} onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <p className={`text-sm font-bold flex items-center gap-2 ${txtMain(light)}`}><Sparkles size={16} className="text-[#E9641A]" /> Assistant IA</p>
          <button onClick={onClose} data-testid="nl-ai-close" className={`p-1.5 ${txtSub(light)} hover:text-red-400`}><X size={16} /></button>
        </div>
        <div className={`flex rounded-lg p-0.5 mb-4 ${light ? 'bg-gray-100' : 'bg-white/5'}`}>
          {[['subject', 'Objet & pré-header'], ['full', 'Newsletter complète']].map(([id, lbl]) => (
            <button key={id} data-testid={`nl-ai-tab-${id}`} onClick={() => setTab(id)}
              className={`flex-1 px-3 py-2 text-xs font-bold rounded-md ${tab === id ? 'bg-[#E9641A] text-white' : light ? 'text-gray-500' : 'text-white/40'}`}>{lbl}</button>
          ))}
        </div>
        <textarea data-testid="nl-ai-brief" rows={3} value={brief} onChange={e => setBrief(e.target.value)}
          placeholder={tab === 'subject' ? 'Ex : sortie du nouveau documentaire sur la Palestine ce vendredi' : 'Ex : newsletter mensuelle avec les nouveautés jeunesse et une promo -20% sur l\'abonnement annuel'}
          className={`w-full text-sm rounded-lg px-3 py-2.5 outline-none border mb-3 ${light ? 'bg-white border-gray-200 text-gray-900 focus:border-[#E9641A]' : 'bg-white/5 border-white/10 text-white focus:border-[#E9641A]'}`} />
        <button onClick={generate} disabled={busy} data-testid="nl-ai-generate"
          className="w-full px-4 py-2.5 rounded-lg bg-[#E9641A] hover:bg-[#FE975E] text-white text-sm font-bold disabled:opacity-50 flex items-center justify-center gap-2">
          <Wand2 size={15} /> {busy ? 'Génération en cours…' : 'Générer avec l\'IA'}
        </button>

        {tab === 'subject' && subjects && (
          <div className="mt-4 space-y-2" data-testid="nl-ai-subjects">
            {subjects.map((s, i) => (
              <button key={i} data-testid={`nl-ai-subject-${i}`} onClick={() => { onApplySubject(s); toast.success('Objet appliqué ✅'); onClose(); }}
                className={`w-full text-left p-3 rounded-lg border transition-colors ${light ? 'border-gray-200 hover:border-[#E9641A]' : 'border-white/10 hover:border-[#E9641A]'}`}>
                <p className={`text-sm font-bold ${txtMain(light)}`}>{s.subject}</p>
                <p className={`text-xs mt-0.5 ${txtSub(light)}`}>{s.preheader}</p>
              </button>
            ))}
          </div>
        )}
        {tab === 'full' && full && (
          <div className={`mt-4 p-3 rounded-lg border ${light ? 'border-gray-200 bg-gray-50' : 'border-white/10 bg-white/3'}`} data-testid="nl-ai-full-result">
            <p className={`text-sm font-bold ${txtMain(light)}`}>{full.subject}</p>
            <p className={`text-xs mt-0.5 ${txtSub(light)}`}>{full.preheader}</p>
            <p className={`text-xs mt-2 ${txtSub(light)}`}>{(full.blocks || []).length} blocs générés (titres, textes, boutons)</p>
            <button data-testid="nl-ai-apply-full" onClick={() => { onApplyBlocks(full); toast.success('Newsletter insérée ✅'); onClose(); }}
              className="mt-3 w-full px-4 py-2 rounded-lg bg-[#E9641A] hover:bg-[#FE975E] text-white text-xs font-bold">Insérer dans la newsletter</button>
          </div>
        )}
      </div>
    </div>
  );
}
